/* Ultrabling: phone colour swatches for iPhone 17 Pro / 18 Pro mockups.
   Mockup slides are rendered by snippets/product-media.liquid with
   data-ub-series ("17" | "18") and data-ub-colour (handle). The selected
   variant's own image is visible, the rest are hidden. This script adds the
   swatch row under the Phone Model select, swaps the visible mockup without a
   reload, scrolls to it, and saves the colour as the hidden line item
   property "_Phone colour". Cart images and the iPhone 18 series page are
   handled in assets/ub-cart-colour.js. */
(function () {
  if (window.__ubPhoneColour) return;
  window.__ubPhoneColour = true;

  var COLOURS = {
    '18': [
      { id: 'burgundy', name: 'Burgundy', hex: '#6a2c38' },
      { id: 'glacier', name: 'Glacier', hex: '#c3d0de' },
      { id: 'black', name: 'Black', hex: '#2a2a2c' },
      { id: 'silver', name: 'Silver', hex: '#d6d6d8' }
    ],
    '17': [
      { id: 'silver', name: 'Silver', hex: '#dcdcdc' },
      { id: 'cosmic-orange', name: 'Cosmic Orange', hex: '#f08a4f' },
      { id: 'deep-blue', name: 'Deep Blue', hex: '#3b4258' }
    ]
  };
  var DEFAULT = { '18': 'burgundy', '17': 'silver' };
  var STORE_KEY = 'ubPhoneColour';
  var PROP = 'properties[_Phone colour]';

  function readStore() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }
  function writeStore(series, id) {
    try { var s = readStore(); s[series] = id; localStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) {}
  }
  var chosen = readStore();

  function seriesOf(model) {
    model = (model || '').toLowerCase();
    if (model.indexOf('iphone 18 pro') > -1) return '18';
    if (model.indexOf('iphone 17 pro') > -1) return '17';
    return '';
  }
  function colourInfo(series, id) {
    var list = COLOURS[series] || [];
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return { id: id, name: id.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }), hex: '#ccc' };
  }

  function rootFor(gallery) {
    return gallery.closest('.shopify-section') || gallery.closest('section') || document;
  }
  function modelSelectFor(root) {
    var sel = root.querySelector('select[name="options[Phone Model]"]');
    if (sel) return sel;
    var all = root.querySelectorAll('variant-picker select');
    for (var i = 0; i < all.length; i++) {
      var opts = all[i].options;
      for (var j = 0; j < opts.length; j++) if (seriesOf(opts[j].value)) return all[i];
    }
    return null;
  }
  function formsFor(gallery, root) {
    var forms = [];
    var main = document.getElementById(gallery.getAttribute('form'));
    if (main) forms.push(main);
    root.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      if (forms.indexOf(f) === -1 && !f.closest('.ub-pc-skip')) forms.push(f);
    });
    return forms;
  }

  function setProperty(gallery, root, value) {
    formsFor(gallery, root).forEach(function (form) {
      var input = form.querySelector('input[data-ub-pc-prop]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = PROP;
        input.setAttribute('data-ub-pc-prop', '');
        form.appendChild(input);
      }
      input.value = value || '';
      input.disabled = !value;
    });
  }

  function availableColours(gallery, series) {
    var found = {};
    gallery.querySelectorAll('.product__media-list [data-ub-series="' + series + '"]').forEach(function (el) {
      found[el.getAttribute('data-ub-colour')] = true;
    });
    var ordered = (COLOURS[series] || []).map(function (c) { return c.id; }).filter(function (id) { return found[id]; });
    Object.keys(found).forEach(function (id) { if (ordered.indexOf(id) === -1) ordered.push(id); });
    return ordered;
  }

  function moveFirstAndHideOthers(container, selector, target) {
    if (!container || !target) return false;
    var changed = false;
    if (container.firstElementChild !== target) {
      container.insertBefore(target, container.firstElementChild);
      changed = true;
    }
    container.querySelectorAll(selector).forEach(function (el) {
      var hide = el !== target;
      if (el.hidden !== hide) { el.hidden = hide; changed = true; }
    });
    return changed;
  }

  function headerOffset() {
    var h = document.querySelector('sticky-header, .header-section, header');
    var r = h ? h.getBoundingClientRect() : null;
    return r && r.bottom > 0 && r.bottom < 200 ? r.bottom : 0;
  }

  function scrollToSlide(gallery, slide) {
    var slider = slide.parentElement && slide.parentElement.closest('slider-element');
    if (slider) slider.scrollTo({ left: 0, behavior: 'smooth' });
    var top = gallery.getBoundingClientRect().top;
    var off = headerOffset();
    if (top < off || top > window.innerHeight * 0.5) {
      window.scrollTo({ top: window.pageYOffset + top - off - 12, behavior: 'smooth' });
    }
  }

  function applyColour(gallery, series, id, scroll) {
    var list = gallery.querySelector('.product__media-list');
    if (!list) return;
    var sel = '[data-ub-series="' + series + '"][data-ub-colour="' + id + '"]';
    var slide = list.querySelector('.product__media' + sel);
    if (!slide) return;
    // Hide mockups of the other series too
    var changed = moveFirstAndHideOthers(list, '.product__media[data-ub-series]', slide);
    var dots = gallery.querySelector('media-dots');
    if (dots) {
      var thumb = dots.querySelector('[data-media-id="' + slide.getAttribute('data-media-id') + '"]');
      if (thumb && moveFirstAndHideOthers(dots, '[data-ub-series]', thumb)) changed = true;
      dots.querySelectorAll('[aria-current]').forEach(function (b) { b.setAttribute('aria-current', b === thumb ? 'true' : 'false'); });
      if (changed && typeof dots.resetIndexes === 'function') { try { dots.resetIndexes(); } catch (e) {} }
    }
    if (changed && typeof gallery.countMediaGallery === 'function') { try { gallery.countMediaGallery(); } catch (e) {} }
    if (scroll) scrollToSlide(gallery, slide);
  }

  function renderRow(row, series, ids, current) {
    var sig = series + ':' + ids.join(',') + ':' + current;
    if (row.getAttribute('data-sig') === sig) return;
    row.setAttribute('data-sig', sig);
    var info = colourInfo(series, current);
    var html = '<p class="ub-pc__label">Your iPhone colour: <strong>' + info.name + '</strong></p><div class="ub-pc__row" role="radiogroup" aria-label="iPhone colour">';
    ids.forEach(function (id) {
      var c = colourInfo(series, id);
      html += '<button type="button" class="ub-pc__swatch' + (id === current ? ' is-active' : '') + '" role="radio" aria-checked="' + (id === current) + '" data-ub-pc-pick="' + id + '" title="' + c.name + '" aria-label="' + c.name + '"><span style="background:' + c.hex + '"></span></button>';
    });
    html += '</div>';
    row.innerHTML = html;
  }

  function sync(gallery, opts) {
    opts = opts || {};
    var root = rootFor(gallery);
    var list = gallery.querySelector('.product__media-list');
    if (list && gallery.__ubList !== list) {
      gallery.__ubList = list;
      gallery.__ubServerFirst = list.firstElementChild ? list.firstElementChild.getAttribute('data-media-id') : '';
    }
    var select = modelSelectFor(root);
    if (!select) return;
    var series = seriesOf(select.value);
    var wrap = select.closest('.variant-input-wrapper') || select.parentElement;
    var row = root.querySelector('[data-ub-pc]');
    var ids = series ? availableColours(gallery, series) : [];

    if (!series || !ids.length) {
      if (row) row.hidden = true;
      setProperty(gallery, root, '');
      return;
    }
    if (!row) {
      row = document.createElement('div');
      row.className = 'ub-pc';
      row.setAttribute('data-ub-pc', '');
      wrap.insertAdjacentElement('afterend', row);
    } else if (row.previousElementSibling !== wrap && wrap.parentElement) {
      wrap.insertAdjacentElement('afterend', row);
    }
    row.hidden = false;
    row.__ubGallery = gallery;

    var current = opts.pick || chosen[series];
    if (ids.indexOf(current) === -1) current = ids.indexOf(DEFAULT[series]) > -1 ? DEFAULT[series] : ids[0];
    renderRow(row, series, ids, current);
    applyColour(gallery, series, current, !!opts.scroll);
    setProperty(gallery, root, colourInfo(series, current).name);
  }

  var pending = new WeakMap();
  function schedule(gallery, opts) {
    if (pending.get(gallery)) return;
    pending.set(gallery, true);
    setTimeout(function () { pending.delete(gallery); sync(gallery, opts); }, 30);
  }

  function watch(gallery) {
    if (gallery.__ubWatched) return;
    gallery.__ubWatched = true;
    function touchesPicker(nodes) {
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.nodeType === 1 && (n.matches('variant-picker, [data-ub-pc]') || n.querySelector('variant-picker'))) return true;
      }
      return false;
    }
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (gallery.contains(r.target) || (r.target.closest && r.target.closest('variant-picker')) || touchesPicker(r.addedNodes) || touchesPicker(r.removedNodes)) {
          sync(gallery);
          return;
        }
      }
    }).observe(rootFor(gallery), { childList: true, subtree: true });
    sync(gallery);
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(watch);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ub-pc-pick]');
    if (!btn) return;
    var row = btn.closest('[data-ub-pc]');
    var gallery = row && row.__ubGallery;
    if (!gallery) return;
    var select = modelSelectFor(rootFor(gallery));
    var series = select ? seriesOf(select.value) : '';
    if (!series) return;
    var id = btn.getAttribute('data-ub-pc-pick');
    chosen[series] = id;
    writeStore(series, id);
    sync(gallery, { pick: id, scroll: true });
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'SELECT') return;
    var root = t.closest('.shopify-section') || document;
    root.querySelectorAll('media-gallery').forEach(function (g) { schedule(g); });
  });

  /* ---------- MagSafe / Non MagSafe only: no jump to the gallery, no gallery reload ---------- */
  var skipScrollUntil = 0;
  var keepGalleryUntil = 0;
  function magsafeOnly() { skipScrollUntil = keepGalleryUntil = Date.now() + 8000; }
  function isMagsafeSelect(el) { return el && el.tagName === 'SELECT' && /magsafe/i.test(el.name || ''); }
  document.addEventListener('click', function (e) {
    var pill = e.isTrusted && e.target.closest && e.target.closest('.ub-pill--magsafe');
    if (pill && !pill.classList.contains('is-active') && !pill.classList.contains('is-disabled-hard')) magsafeOnly();
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'SELECT') return;
    if (/phone model/i.test(t.name || '')) skipScrollUntil = keepGalleryUntil = 0;
    else if (e.isTrusted && isMagsafeSelect(t)) magsafeOnly();
  }, true);
  if (window.customElements) {
    customElements.whenDefined('media-gallery').then(function () {
      var MG = customElements.get('media-gallery');
      var proto = MG && MG.prototype;
      if (!proto || typeof proto.setActiveMedia !== 'function' || proto.setActiveMedia.__ubWrapped) return;
      var original = proto.setActiveMedia;
      var wrapped = function () {
        if (skipScrollUntil && Date.now() < skipScrollUntil) { skipScrollUntil = 0; return; }
        return original.apply(this, arguments);
      };
      wrapped.__ubWrapped = true;
      proto.setActiveMedia = wrapped;
    });
    // The theme re-renders the whole gallery on every variant change. When only MagSafe
    // changed and the new gallery starts with the same image, keep the current one.
    customElements.whenDefined('product-info').then(function () {
      var PI = customElements.get('product-info');
      var proto = PI && PI.prototype;
      if (!proto || typeof proto.updateSourceFromDestination !== 'function' || proto.updateSourceFromDestination.__ubWrapped) return;
      var original = proto.updateSourceFromDestination;
      var wrapped = function (parsedHTML, id) {
        if (id === 'ProductGallery' && keepGalleryUntil && Date.now() < keepGalleryUntil) {
          keepGalleryUntil = 0;
          try {
            var key = id + '-' + this.sectionId + '-' + this.productId;
            var source = parsedHTML.getElementById(key);
            var current = document.getElementById(key);
            var first = source && source.querySelector('.product__media-list > .product__media');
            if (current && first && current.__ubServerFirst && first.getAttribute('data-media-id') === current.__ubServerFirst) return;
          } catch (e) {}
        }
        return original.apply(this, arguments);
      };
      wrapped.__ubWrapped = true;
      proto.updateSourceFromDestination = wrapped;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* ---------- Faster colour switching, without slowing the first page load ----------
   1. Nothing extra loads until the shopper picks an iPhone 17 Pro / 18 Pro model.
   2. Tiny previews (~5-10 KB each) of that series' colours load when the swatches
      come into view, so a tap always shows the right colour instantly (soft blur),
      then the sharp photo fades in.
   3. Full-size photos of the other colours load one at a time in the background,
      only after the page and the main photo have finished loading:
        - fast connection (4G/Wi-Fi): right after the page settles
        - slower or unknown connection: once the swatches are on screen
        - Data Saver or 2G: never in the background, only the colour tapped
   4. A finger touching a swatch starts that photo's download before the tap ends. */
(function () {
  if (window.__ubPcSpeed) return;
  window.__ubPcSpeed = true;

  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  function mode() {
    if (conn && conn.saveData) return 'tap';
    var t = conn && conn.effectiveType;
    if (t === 'slow-2g' || t === '2g') return 'tap';
    if (t === '4g') return 'idle';
    return 'visible';
  }

  var css = document.createElement('style');
  css.textContent =
    '.ub-lqip{position:absolute;inset:0;width:100%;height:100%;z-index:2;pointer-events:none;filter:blur(6px);transform:scale(1.03);transition:opacity .35s ease;}' +
    '.ub-lqip.is-done{opacity:0;}' +
    '.ub-pc__swatch.is-loading{border-color:rgba(0,0,0,.35);border-top-color:#111;animation:ubPcSpin .8s linear infinite;}' +
    '@keyframes ubPcSpin{to{transform:rotate(360deg)}}' +
    '@media (prefers-reduced-motion:reduce){.ub-pc__swatch.is-loading{animation:none}}';
  document.head.appendChild(css);

  function loaded(img) { return img && img.complete && img.naturalWidth > 0; }
  function tinyUrl(img) {
    var set = (img && (img.getAttribute('srcset') || img.getAttribute('data-srcset'))) || '';
    var parts = set.split(',');
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim().split(/\s+/);
      if (p[1] === '200w' || p[1] === '300w') return p[0];
    }
    return '';
  }
  function slideFor(gallery, series, id) {
    return gallery.querySelector('.product__media-list .product__media[data-ub-series="' + series + '"][data-ub-colour="' + id + '"]');
  }
  function imgOf(slide) { return slide && slide.querySelector('img'); }

  var tinyDone = {};
  function warmTiny(img) {
    var u = tinyUrl(img);
    if (!u || tinyDone[u]) return;
    tinyDone[u] = true;
    var i = new Image();
    i.decoding = 'async';
    i.src = u;
  }

  function loadFull(img, high) {
    if (!img || loaded(img)) return;
    if (high && 'fetchPriority' in img) img.fetchPriority = 'high';
    if (img.loading !== 'eager') img.loading = 'eager';
  }

  // Background queue: one photo at a time so it never competes with what the shopper sees.
  var queue = [];
  var busy = false;
  function pump() {
    if (busy) return;
    var img;
    while ((img = queue.shift()) && (loaded(img) || !img.isConnected)) {}
    if (!img) return;
    busy = true;
    var done = function () { busy = false; setTimeout(pump, 150); };
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
    loadFull(img, false);
    setTimeout(function () { if (busy && !loaded(img)) { busy = false; pump(); } }, 15000);
  }

  function state(row) {
    var gallery = row && row.__ubGallery;
    var sig = row && row.getAttribute('data-sig');
    if (!gallery || !sig || row.hidden) return null;
    var p = sig.split(':');
    return { gallery: gallery, series: p[0], ids: p[1] ? p[1].split(',') : [], current: p[2] };
  }

  function whenMainReady(gallery, cb) {
    var first = gallery.querySelector('.product__media-list .product__media:not([hidden]) img');
    var go = function () {
      if (window.requestIdleCallback) requestIdleCallback(cb, { timeout: 2500 });
      else setTimeout(cb, 600);
    };
    var afterLoad = function () {
      if (!first || loaded(first)) go();
      else { first.addEventListener('load', go, { once: true }); first.addEventListener('error', go, { once: true }); }
    };
    if (document.readyState === 'complete') afterLoad();
    else window.addEventListener('load', afterLoad, { once: true });
  }

  function plan(row, reason) {
    var s = state(row);
    if (!s) return;
    var others = s.ids.slice(s.ids.indexOf(s.current) + 1).concat(s.ids.slice(0, Math.max(0, s.ids.indexOf(s.current))));
    var imgs = others.map(function (id) { return imgOf(slideFor(s.gallery, s.series, id)); }).filter(Boolean);
    var m = mode();
    if (reason === 'visible' || m === 'idle') imgs.forEach(warmTiny);
    var warmFull = (m === 'idle') || (m === 'visible' && reason === 'visible');
    if (!warmFull) return;
    whenMainReady(s.gallery, function () {
      imgs.forEach(function (img) { if (queue.indexOf(img) === -1) queue.push(img); });
      pump();
    });
  }

  // Watch swatch rows: re-plan whenever the series or the gallery changes.
  var seen = new WeakMap();
  var io = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) plan(e.target, 'visible'); });
  }, { rootMargin: '200px 0px' }) : null;
  function scan() {
    document.querySelectorAll('[data-ub-pc]').forEach(function (row) {
      var key = (row.getAttribute('data-sig') || '').split(':').slice(0, 2).join(':') + '|' + (row.__ubGallery && row.__ubGallery.querySelector('.product__media-list') ? 1 : 0);
      var list = row.__ubGallery && row.__ubGallery.querySelector('.product__media-list');
      if (seen.get(row) === key && row.__ubPlannedList === list) return;
      seen.set(row, key);
      row.__ubPlannedList = list;
      plan(row, 'page');
      if (io) { io.unobserve(row); io.observe(row); }
    });
  }
  var scanTimer = 0;
  function scheduleScan() { clearTimeout(scanTimer); scanTimer = setTimeout(scan, 120); }
  new MutationObserver(scheduleScan).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-sig'] });
  scheduleScan();

  // Touch / hover on a swatch: start that photo now.
  function intent(e) {
    var btn = e.target.closest && e.target.closest('[data-ub-pc-pick]');
    var s = btn && state(btn.closest('[data-ub-pc]'));
    if (!s) return;
    var img = imgOf(slideFor(s.gallery, s.series, btn.getAttribute('data-ub-pc-pick')));
    warmTiny(img);
    loadFull(img, true);
  }
  document.addEventListener('pointerdown', intent, true);
  document.addEventListener('mouseover', intent, true);
  document.addEventListener('focusin', intent, true);

  // Tap: if the sharp photo isn't ready yet, show the tiny one blurred right away.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ub-pc-pick]');
    var s = btn && state(btn.closest('[data-ub-pc]'));
    if (!s) return;
    var slide = slideFor(s.gallery, s.series, btn.getAttribute('data-ub-pc-pick'));
    var img = imgOf(slide);
    if (!img || loaded(img)) return;
    loadFull(img, true);
    var old = slide.querySelector('.ub-lqip');
    if (old) old.remove();
    var u = tinyUrl(img);
    if (u) {
      var lq = document.createElement('img');
      lq.className = 'ub-lqip';
      lq.alt = '';
      lq.setAttribute('aria-hidden', 'true');
      lq.style.objectFit = getComputedStyle(img).objectFit || 'cover';
      lq.src = u;
      slide.appendChild(lq);
    }
    var id = btn.getAttribute('data-ub-pc-pick');
    var finish = function () {
      var lqip = slide.querySelector('.ub-lqip');
      if (lqip) { lqip.classList.add('is-done'); setTimeout(function () { lqip.remove(); }, 400); }
      document.querySelectorAll('[data-ub-pc-pick="' + id + '"].is-loading').forEach(function (b) { b.classList.remove('is-loading'); });
    };
    img.addEventListener('load', finish, { once: true });
    img.addEventListener('error', finish, { once: true });
    // The row is re-rendered by the click; mark the new swatch as loading.
    setTimeout(function () {
      if (loaded(img)) return finish();
      document.querySelectorAll('[data-ub-pc-pick="' + id + '"]').forEach(function (b) { b.classList.add('is-loading'); });
    }, 0);
  }, true);
})();
